import { Avatar } from "@material-ui/core";
import { formatDate } from 'helper/dateFormat';
import React from 'react';
import { mailTo, phoneTo, smsTo } from "utils/contactTo";
import Email from "../../../assets/icons/mail.svg";
import Call from "../../../assets/icons/phone.svg";
import Message from "../../../assets/icons/sms.svg";
import { fullNameFirstLetter } from "../helper/getFirstChartFromFullName";

const EventDrawerList = ({ eventsList, handelSelectEventMember }) => {


  return (
    <div className="Scroll pr-2" style={{ height: "70vh" }}>
      {!!eventsList?.length ? eventsList?.map((item) => {
        return (
          <div
            className="d-flex justify-content-between py-2 mt-4 hover">
            <div className="d-flex align-items-center flex-grow-1" onClick={() => handelSelectEventMember(item)}>
              <Avatar className="mr-4" alt="img" src={item?.avtar}>
                {fullNameFirstLetter(item?.fname, item?.lname)?.toString()?.toUpperCase()}
              </Avatar>
              <div className="ml-2">
                <p className="m-0 event-member-name">{item?.fname + " " + item?.lname}</p>
                <p className="event-member-age text-muted m-0">{formatDate({ date: item.date, formatType: "defaultWithUTC" })}</p>
              </div>
            </div>
            <div className="d-flex pastoral-event-actions">
              <a 
                className="btn pastoral-event-action" 
                href={phoneTo({ phone: item.mobile })}
                style={item.mobile ? {} : { pointerEvents: "none", opacity: 0.5 }}
              >
                <img
                  className="hover"
                  src={Call}
                />
              </a>
              <a 
                className="btn pastoral-event-action" 
                href={smsTo({ phone: item.mobile, content: item.memo || "" })}
                style={(item.mobile) ? {} : { pointerEvents: "none", opacity: 0.5 }}
              >
                <img
                  className="hover"
                  src={Message}
                />
              </a>
              <a 
                className="btn pastoral-event-action" 
                href={mailTo({ email: item.email, content: item.memo || "" })}
                style={(item.email) ? {} : { pointerEvents: "none", opacity: 0.5 }}

              >
                <img
                  className="hover"
                  src={Email}
                />
              </a>
            </div>
          </div>
        );
      }) : (
        <div className="mt-5 text-center">
          <h3 className="text-center">No Data</h3>
        </div>
      )}
    </div>
  )
}

export default EventDrawerList